<template>
  <div style="min-height: 100%; min-width: 100%" v-bind:class="{
    'd-flex justify-content-center align-items-center': true,
    'spinner-small': size === 'small',
    'spinner-large': size === 'large'
  }">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PreLoader',
  props: {
    size: {
      type: String,
      default: 'small'
    },
  },

}
</script>
<style lang="scss" scoped>


.spinner-small {

  .lds-spinner {
    width: 40px;
    height: 40px;
  }

  .lds-spinner div {
    transform-origin: 20px 20px;
  }

  .lds-spinner div:after {
    top: 1.5px;
    left: 16px;
    width: 6px;
    height: 4px;
  }
}


.spinner-large {

  .lds-spinner {
    width: 80px;
    height: 80px;
  }

  .lds-spinner div {
    transform-origin: 40px 40px;
  }

  .lds-spinner div:after {
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
  }
}


.lds-spinner {
  color: official;
  display: inline-block;
  position: relative;
}

.lds-spinner div {
  animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  border-radius: 20%;
  background: #cb6e00;
}

.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}

@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}


</style>